/**
 * Language Context
 * 
 * DEPRECATED: This context now wraps the Zustand language store for backwards compatibility.
 * New code should import directly from '@/stores/language'.
 * 
 * This file is maintained for backwards compatibility with existing imports.
 * All state is managed by the Zustand store in @/stores/language.
 */

import React, { createContext, useContext } from 'react';
import { useLanguageStore } from '@/stores/language';
import { Language, BilingualText } from '@/types/common';
import type { TranslateFn } from '@/stores/language';

interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  /** Translate bilingual content to current language */
  t: TranslateFn;
  /** Get text for specific language from bilingual content */
  getText: (text: BilingualText, lang?: Language) => string;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

/**
 * @deprecated Use useLanguageStore from '@/stores/language' directly
 * This provider is maintained for backwards compatibility.
 */
export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // All state now comes from Zustand store
  const store = useLanguageStore();
  
  return (
    <LanguageContext.Provider value={store}>
      {children}
    </LanguageContext.Provider>
  );
};

/**
 * @deprecated Use useLanguageStore from '@/stores/language' directly
 * This hook is maintained for backwards compatibility.
 */
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  
  // Fallback to direct store access if used outside provider
  // This allows gradual migration away from LanguageProvider
  if (context === undefined) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useLanguageStore();
  }
  
  return context;
};
